import React, { useRef, useState, useEffect } from 'react';
import { FaSearch } from 'react-icons/fa';
import './formulario.css';
import API from '../../providers/api';
import { Row, Col, Spinner, Input, Button, Badge } from 'reactstrap'
import logo from '../../assets/img/logo.png'
import bannerTop from '../../assets/img/banner-top.jpeg'
import success from '../../assets/img/success.png'
import fail from '../../assets/img/fail.png'
import { alert } from '../../helpers/alert';
import stateSelect from '../JsonData/state.json'
import moment from 'moment'
import DataTable from "react-data-table-component";

const Formulario = () => {

    const [data, setData] = useState([])
    const [loading, setLoading] = useState(false)
    const [validarCotizacion, setValidarCotizacion] = useState(false)
    const [idCotizacion, setIdCotizacion] = useState('')
    const [totalProductos, setTotalProductos] = useState(0)
    const [totalIVA, setTotalIVA] = useState(0)
    const [total, setTotal] = useState(0)
    const [resultadoCotizacion, setResultadoCotizacion] = useState(null)

    const formatCash = Intl.NumberFormat("es-CO", {
        style: "currency",
        currency: "COP",
    });

    useEffect(() => {
        const queryParameters = new URLSearchParams(window.location.search)
        const nro = queryParameters.get("nro")
        buscarCotizacion(nro)
    }, [])

    const buscarCotizacion = (nro) => {
        setLoading(true)
        setIdCotizacion(nro)
        API.buscarCotizacion(nro)
        .then(data => data.json())
        .then(dataJson => {
            if (dataJson.success == true) {
                    setData(dataJson.data)
                    setTotalIVA(dataJson.data[0].valor_iva)
                    setTotal(dataJson.data[0].total)
                    setTotalProductos((dataJson.data.reduce((a, b) => a + b.precio_producto * b.cantidad, 0)))
                if(dataJson.data[0].validar_cotizacion == null){
                    setValidarCotizacion(false)
                }else if(dataJson.data[0].validar_cotizacion == true){
                    setValidarCotizacion(true)
                    setResultadoCotizacion(dataJson.data[0].validar_cotizacion)
                }
                else if(dataJson.data[0].validar_cotizacion == false){
                    setValidarCotizacion(true)
                    setResultadoCotizacion(dataJson.data[0].validar_cotizacion)
                }else
                    setValidarCotizacion(true)
            }else{
                setData([])
                setValidarCotizacion(true)
            }
            setLoading(false)
        })
        .catch((e) => {
            console.log("Error =>", e)
        })
    }

    const guardarAprobacion = (aprobado) => {
        setResultadoCotizacion(aprobado)
        setLoading(true)
        API.guardarAprobacionCotizacion(idCotizacion, aprobado)
        .then(data => data.json())
        .then(dataJson => {
            if (dataJson.success == true) {
                setValidarCotizacion(true)
                alert('Success!', `Se ha guardado la desición de la cotización`, 'success', 'Cerrar')
            }else{
                alert('Error!', `No se ha guardado la desición de lacotización`, 'danger', 'Cerrar')
            }
            setLoading(false)
        })
        .catch((e) => {
            console.log("Error =>", e)
        })
    }

    return (
        <div className='flex-container'>
            <div>
                <div className='cardForm' style={{background:'#002240'}}>
                    <div>
                        <Row>
                            <Col lg='6' style={{padding:'15px'}}>
                                <a href="https://fergoingenieria.com.co/" style={{padding:'10px'}}><img src={logo} alt='Logo fergo' style={{width:'100%',maxWidth:'150px'}} /></a>
                            </Col>
                        </Row>
                    </div>
                </div>

                <Row className="mt-4">
                    <Col lg="12">
                        {
                            loading == false ?
                                    <>
                                        <Row className="text-center">
                                            <Col>
                                                <h3>Cotización Nº {idCotizacion}</h3>
                                            </Col>
                                        </Row>
                                        <table className="table table-bordered table-hover">
                                            <thead>
                                                <tr>
                                                    <th>No.</th>
                                                    <th>Producto</th>
                                                    <th>Cantidad</th>
                                                    <th>Precio</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {data.map((row, index) => (
                                                    <tr key={index}>
                                                        <td>{(index + 1).toString()}</td>
                                                        <td>{row.nombre_producto}</td>
                                                        <td>{row.cantidad}</td>
                                                        <td>{formatCash.format(row.precio_producto * row.cantidad)}</td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                            <tfoot>
                                                <tr>
                                                    <th colSpan="3" style={{textAlign:'right'}}>Total productos</th>
                                                    <th>{formatCash.format(totalProductos)}</th>
                                                </tr>
                                                <tr>
                                                    <th colSpan="3" style={{textAlign:'right'}}>Total IVA</th>
                                                    <th>{formatCash.format(totalIVA)}</th>
                                                </tr>
                                                <tr>
                                                    <th colSpan="3" style={{textAlign:'right'}}>Total</th>
                                                    <th>{formatCash.format(total)}</th>
                                                </tr>
                                            </tfoot>
                                        </table>
                                        {
                                            !validarCotizacion &&
                                            <Row className="text-center">
                                                <Col lg='12'>
                                                    <Button color="success" onClick={() => guardarAprobacion(true)}>Aprobar</Button>{" "}
                                                    <Button color="danger" onClick={() => guardarAprobacion(false)}>Rechazar</Button>
                                                </Col>
                                            </Row>
                                        }
                                        {
                                            resultadoCotizacion != null &&
                                            <Row className="text-center">
                                                {
                                                    resultadoCotizacion == true ?
                                                    <Col lg='12'>
                                                        <div className='alert alert-success'>Cotización APROBADA</div>
                                                    </Col>
                                                    :
                                                    <Col lg='12'>
                                                        <div className='alert alert-danger'>Cotización RECHAZADA</div>
                                                    </Col>
                                                }
                                            </Row>
                                        }
                                        <Row className="mt-4">
                                            <Col>
                                            <p style={{textAlign:'justify'}}>
                                                <b>Derechos de Propiedad</b>
                                                <br/>
                                                La información transmitida en este e-mail está destinada al uso exclusivo de las personas a quienes esté dirigida y puede contener información confidencial. Toda revisión, retransmisión, diseminación u otro uso de esta información por personas o entidades distintas del destinatario está prohibida. Si usted ha recibido esta comunicación por error, por favor haga caso omiso de su contenido y notifíquese de inmediato al correo que envió el mensaje.
                                                De igual manera todos los documentos adjuntos a este correo son creación de la sociedad <b>FERGO INGENIERÍA S.A.S.</b>, por lo tanto, los derechos de estos son reservados. Queda prohibida su reproducción y/o utilización total o parcial, diferente a los fines establecidos.
                                                <br/><br/>
                                                <b>Derechos de Autor</b>
                                                <br/>
                                                Los datos personales que nos proporcione serán protegidos conforme a lo dispuesto por la Ley 1581 de 2012 y normativa concordante, los cuales serán incorporados y tratados en el sistema de datos personales de nuestra compañía, cuya finalidad es la de mantener relaciones comerciales y/o profesionales. Usted puede ejercer sus derechos reconocidos en la ley respecto a la protección de datos enviando un mensaje a los correos de la compañía o comunicándose a nuestras líneas telefónicas.
                                                <br/><br/>
                                            </p>
                                            </Col>
                                        </Row>
                                        <Row className="text-center mb-4">
                                            <Col style={{fontWeight:'bold'}}>
                                                Quieres conocer más acerca de FERGO INGENIERÍA S.A.S.<br/><br/>
                                                <a style={{textDecoration:'none',padding:'15px',background:'#002240',color:'white',borderRadius:'5px'}} href="https://fergoingenieria.com.co/" target='_blank'>
                                                Visitanos en fergoingenieria.com.co</a>
                                            </Col>
                                        </Row>
                                    </>
                            : <Spinner color="success" />
                        }
                    </Col>
                </Row>

                <div>
                    <Row className='mt-4 text-center' style={{color:'#A1C8DC'}}>
                        <Col>
                            <span>
                                FERGO INGENIERÍA S.A.S. {moment().format('YYYY')}. Powered by <a href="https://ticservice.org/portal" target='_blank'>TIC Service</a>
                            </span>
                        </Col>
                    </Row>
                </div>
            </div>
        </div>
    );
}

export default Formulario;